import React from 'react';

const About = () => {
  return (
    <div style={{ minHeight: '100vh', padding: '120px 20px 80px', backgroundColor: '#ffffff' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '80px' }}>
          <div style={{ 
            display: 'inline-block',
            padding: '8px 20px',
            backgroundColor: '#ede9fe',
            borderRadius: '24px',
            marginBottom: '24px'
          }}>
            <span style={{ color: '#7c3aed', fontSize: '14px', fontWeight: '600', letterSpacing: '0.5px' }}>
              WHO WE ARE
            </span>
          </div>
          <h1 style={{ 
            fontSize: '56px', 
            fontWeight: '800', 
            background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            marginBottom: '24px',
            letterSpacing: '-1px',
            lineHeight: '1.1'
          }}>
            About VentureOS
          </h1>
          <p style={{ 
            fontSize: '22px', 
            color: '#6b7280', 
            maxWidth: '800px', 
            margin: '0 auto',
            lineHeight: '1.6'
          }}>
            Revolutionizing venture capital through AI-powered intelligence and data-driven insights
          </p>
        </div>

        {/* Mission */}
        <section style={{ 
          marginBottom: '100px',
          padding: '60px',
          background: 'linear-gradient(135deg, #f0f9ff 0%, #e0e7ff 100%)',
          borderRadius: '24px',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{ position: 'relative', zIndex: 1 }}>
            <div style={{ marginBottom: '32px' }}>
              <span style={{ 
                fontSize: '14px', 
                fontWeight: '700', 
                color: '#6366f1', 
                textTransform: 'uppercase',
                letterSpacing: '1px'
              }}>
                Our Mission
              </span>
            </div>
            <h2 style={{ 
              fontSize: '38px', 
              fontWeight: '700', 
              color: '#1f2937', 
              marginBottom: '28px',
              lineHeight: '1.3',
              maxWidth: '900px'
            }}>
              Democratizing access to venture capital intelligence for every investor
            </h2>
            <p style={{ 
              fontSize: '19px', 
              lineHeight: '1.8', 
              color: '#4b5563', 
              marginBottom: '24px',
              maxWidth: '850px'
            }}>
              We believe that every investor, from emerging fund managers to established VCs, deserves access to 
              institutional-grade tools and insights. The future of venture capital is data-driven, transparent, and accessible.
            </p>
            <p style={{ 
              fontSize: '19px', 
              lineHeight: '1.8', 
              color: '#4b5563',
              maxWidth: '850px'
            }}>
              By leveraging cutting-edge AI and machine learning, we're building the global operating system for venture capital—a 
              platform that powers intelligent decisions across all private markets.
            </p>
          </div>
        </section>

        {/* Values */}
        <section style={{ marginBottom: '100px' }}>
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <span style={{ 
              fontSize: '14px', 
              fontWeight: '700', 
              color: '#6366f1', 
              textTransform: 'uppercase',
              letterSpacing: '1px'
            }}>
              Our Values
            </span>
            <h2 style={{ 
              fontSize: '42px', 
              fontWeight: '700', 
              color: '#1f2937', 
              marginTop: '16px',
              marginBottom: '20px'
            }}>
              What Drives Us
            </h2>
            <p style={{ fontSize: '18px', color: '#6b7280', maxWidth: '700px', margin: '0 auto' }}>
              Our core principles guide everything we build and every decision we make
            </p>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '32px' }}>
            {[
              {
                title: 'Innovation',
                description: 'Pushing boundaries with cutting-edge AI and machine learning to redefine venture capital intelligence.',
                icon: '🚀',
                gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
              },
              {
                title: 'Transparency',
                description: 'Building trust through open communication, clear processes, and honest relationships.',
                icon: '💎',
                gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)'
              },
              {
                title: 'Excellence',
                description: 'Delivering exceptional quality in every product feature, customer interaction, and support experience.',
                icon: '⭐',
                gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)'
              },
              {
                title: 'Collaboration',
                description: 'Partnering with our community to co-create the future of venture capital together.',
                icon: '🤝',
                gradient: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)'
              }
            ].map((value, index) => (
              <div key={index} style={{
                padding: '40px 32px',
                backgroundColor: '#ffffff',
                borderRadius: '20px',
                border: '1px solid #e5e7eb',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                cursor: 'pointer',
                position: 'relative',
                overflow: 'hidden'
              }}>
                <div style={{
                  width: '70px',
                  height: '70px',
                  background: value.gradient,
                  borderRadius: '16px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '32px',
                  marginBottom: '24px',
                  boxShadow: '0 8px 16px rgba(99, 102, 241, 0.2)'
                }}>
                  {value.icon}
                </div>
                <h3 style={{ 
                  fontSize: '22px', 
                  fontWeight: '700', 
                  color: '#1f2937', 
                  marginBottom: '12px' 
                }}>
                  {value.title}
                </h3>
                <p style={{ 
                  fontSize: '16px', 
                  color: '#6b7280', 
                  lineHeight: '1.7',
                  margin: 0
                }}>
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </section>

        {/* Team Section */}
        <section style={{ marginBottom: '100px' }}>
          <div style={{ textAlign: 'center', marginBottom: '40px' }}>
            <span style={{ 
              fontSize: '14px', 
              fontWeight: '700', 
              color: '#6366f1', 
              textTransform: 'uppercase',
              letterSpacing: '1px'
            }}>
              Our Team
            </span>
            <h2 style={{ 
              fontSize: '42px', 
              fontWeight: '700', 
              color: '#1f2937', 
              marginTop: '16px',
              marginBottom: '20px'
            }}>
              Built by Experts
            </h2>
            <p style={{ fontSize: '18px', lineHeight: '1.8', color: '#6b7280', maxWidth: '800px', margin: '0 auto 60px' }}>
              We're a diverse team of engineers, data scientists, and venture capital professionals united by a common goal: 
              transforming how the world invests in innovation.
            </p>
          </div>
          
          {/* Join CTA */}
          <div style={{
            padding: '60px 40px',
            background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
            borderRadius: '24px',
            color: 'white',
            textAlign: 'center',
            position: 'relative',
            overflow: 'hidden'
          }}>
            <div style={{ position: 'relative', zIndex: 1 }}>
              <div style={{ fontSize: '48px', marginBottom: '20px' }}>💼</div>
              <h3 style={{ fontSize: '32px', fontWeight: '700', marginBottom: '16px', letterSpacing: '-0.5px' }}>
                Join Our Mission
              </h3>
              <p style={{ fontSize: '19px', marginBottom: '32px', opacity: 0.95, maxWidth: '600px', margin: '0 auto 32px' }}>
                We're always looking for talented individuals who are passionate about transforming venture capital through technology.
              </p>
              <a 
                href="/careers" 
                style={{
                  display: 'inline-block',
                  padding: '16px 40px',
                  backgroundColor: 'white',
                  color: '#6366f1',
                  borderRadius: '12px',
                  fontWeight: '700',
                  textDecoration: 'none',
                  fontSize: '17px',
                  boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
                  transition: 'transform 0.2s ease'
                }}
              >
                View Open Positions →
              </a>
            </div>
          </div>
        </section>

        {/* Back to Home */}
        <div style={{ textAlign: 'center' }}>
          <a 
            href="/" 
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              padding: '14px 28px',
              color: '#6b7280',
              border: '2px solid #e5e7eb',
              borderRadius: '12px',
              fontWeight: '600',
              textDecoration: 'none',
              fontSize: '16px',
              transition: 'all 0.2s ease'
            }}
          >
            ← Back to Home
          </a>
        </div>
      </div>
    </div>
  );
};

export default About;
